import { router } from '@inertiajs/react'
import { Users, Stethoscope } from 'lucide-react'
import type { PostCategory } from '@/types'

interface FilterTabsProps {
  activeFilter: 'all' | 'specialty'
  activeCategory: string | null
  currentSpecialty: string
  categories: PostCategory[]
  showSpecialtyFilter?: boolean
}

const TABS = [
  { id: 'all' as const, label: 'Tous', icon: Users },
  { id: 'specialty' as const, label: 'Ma spécialité', icon: Stethoscope }
]

export default function FilterTabs({ activeFilter, activeCategory, currentSpecialty, categories, showSpecialtyFilter = true }: FilterTabsProps) {
  const handleFilterChange = (filterId: 'all' | 'specialty') => {
    if (filterId === 'all') {
      router.get('/community', {}, { preserveState: true, preserveScroll: true })
    } else {
      router.get('/community', { specialty: 'mine' }, { preserveState: true, preserveScroll: true })
    }
  }

  const handleCategoryChange = (categorySlug: string | null) => {
    const params: Record<string, string> = {}
    if (activeFilter === 'specialty') {
      params.specialty = 'mine'
    }
    if (categorySlug) {
      params.category = categorySlug
    }
    router.get('/community', params, { preserveState: true, preserveScroll: true })
  }

  return (
    <div className="mb-6">
      <div className="flex flex-wrap items-center gap-2">
        {/* Main filter tabs */}
        {TABS.filter(tab => showSpecialtyFilter || tab.id !== 'specialty').map((tab) => {
          const Icon = tab.icon
          const isActive = activeFilter === tab.id && !activeCategory
          return (
            <button
              key={tab.id}
              onClick={() => handleFilterChange(tab.id)}
              className={`inline-flex items-center gap-2 px-4 py-2 text-sm font-medium rounded-full transition-colors ${
                isActive
                  ? 'bg-tessan-primary text-white'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              <Icon className="w-4 h-4" />
              {tab.label}
              {tab.id === 'specialty' && (
                <span className={`text-xs ${isActive ? 'text-white/80' : 'text-gray-400'}`}>({currentSpecialty})</span>
              )}
            </button>
          )
        })}

        {/* Separator */}
        {categories.length > 0 && (
          <div className="h-6 w-px bg-gray-300 mx-2" />
        )}

        {/* Category filters */}
        {categories.map((category) => {
          const isActive = activeCategory === category.name
          return (
            <button
              key={category.id}
              onClick={() => handleCategoryChange(isActive ? null : category.slug)}
              className={`inline-flex items-center px-3 py-2 text-sm font-medium rounded-full transition-colors ${
                isActive
                  ? 'bg-tessan-cream text-tessan-primary ring-1 ring-tessan-primary'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {category.name}
            </button>
          )
        })}
      </div>
    </div>
  )
}
